import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AccountDetailObj, ChangePasswordPrlObj, ManagerInfoObj} from 'mx-core';

const ACCOUNT_URL = '/rest/account';
const ACCOUNT_DOCUMENTS_URL = '/rest/account/documents/';

@Injectable({
    providedIn: 'root'
})
export class PrlAccountDataService {

    constructor(private httpClient: HttpClient) {
    }

    public getCurrentAccount(): Observable<any> {
        return this.httpClient.get(ACCOUNT_URL);
    }

    public getAccountDisplayName(): Observable<string> {
        return this.httpClient.get(ACCOUNT_URL + '/display-name', {responseType: 'text'});
    }

    public isAllowSubaffiliates(): Observable<boolean> {
        let url = ACCOUNT_URL + '/allow-subaffiliates';
        return this.httpClient.get<boolean>(url);
    }

    public getRefererUrl(): Observable<string> {
        let url = ACCOUNT_URL + '/referer-url';
        return this.httpClient.get(url, {responseType: 'text'});
    }

    public getAccountDetails(): Observable<AccountDetailObj> {
        return this.httpClient.get<AccountDetailObj>(`${ACCOUNT_URL}/details`);
    }

    public updateAccountData(obj: AccountDetailObj): Observable<HttpResponse<void>> {
        return this.httpClient.put<void>(ACCOUNT_URL, obj, {observe: 'response'});
    }

    public getManagerInfo(): Observable<ManagerInfoObj> {
        return this.httpClient.get<ManagerInfoObj>(`${ACCOUNT_URL}/managerInfo`);
    }

    public getDocument(id: number): Observable<HttpResponse<Blob>> {
        return this.httpClient.get(`${ACCOUNT_DOCUMENTS_URL}${id}`, {
            observe: 'response',
            responseType: 'blob'
        });
    }

    public removeDocument(id: number): Observable<void> {
        return this.httpClient.delete<void>(`${ACCOUNT_DOCUMENTS_URL}${id}`);
    }

    changePassword(passwordObj: ChangePasswordPrlObj): Observable<void> {
        return this.httpClient.post<void>(`${ACCOUNT_URL}/password/change`, passwordObj);
    }
}
